//
//
//
//
//
//
//
//
//
export default {
  name: 'Description',
  props: {
    info: {
      type: Object,

      default() {
        return {};
      }

    }
  }
};